import { render, staticRenderFns } from "./logo-tertiary.vue?vue&type=template&id=75ef9f8b&scoped=true"
import script from "./logo-tertiary.vue?vue&type=script&lang=js"
export * from "./logo-tertiary.vue?vue&type=script&lang=js"
import style0 from "./logo-tertiary.vue?vue&type=style&index=0&id=75ef9f8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ef9f8b",
  null
  
)

export default component.exports